import { Children as reactChildren } from 'react';
import { Box, CSSObject, Select, useMultiStyleConfig } from '@chakra-ui/react';
import RcPagination, {
  PaginationProps as RcPaginationProps,
} from 'rc-pagination';
import 'rc-pagination/assets/index.css';

export interface PaginationProps extends RcPaginationProps {
  selectProps?: CSSObject;
  containerProps?: CSSObject;
}

export const Pagination = (props: PaginationProps) => {
  const localeInfo = {
    items_per_page: '/ page',
    jump_to: 'Go to',
    jump_to_confirm: 'confirm',
    page: 'Page',
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
    page_size: 'Page Size',
  };
  const { onShowSizeChange, containerProps, selectProps, ...rest } = props;
  const styles = useMultiStyleConfig('Pagination', props);

  return (
    <Box sx={{ ...styles.Container, ...containerProps }}>
      <RcPagination
        pageSizeOptions={[10, 20, 50, 100]}
        pageSize={10}
        selectComponentClass={(props) => {
          const { children, ...rest } = props;
          return (
            <Select
              {...rest}
              sx={{ ...styles.PaginationSelect, ...selectProps }}
              onChange={(e) =>
                onShowSizeChange &&
                onShowSizeChange(1, parseInt(e.target.value))
              }
            >
              {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                reactChildren.map(children, (child: any, index) => {
                  if (child?.props.value !== 'NaN') {
                    return <option key={index} {...child?.props} />;
                  }
                })
              }
            </Select>
          );
        }}
        locale={localeInfo}
        hideOnSinglePage
        {...rest}
      />
    </Box>
  );
};
